import { Pill, type PillSize, type PillVariant } from "@src/appV2/redesign/system/ui-components";

interface UrgentShiftPillProps {
  /**
   * If true, the pill will be compact and only show the icon
   */
  compact?: boolean;
  size?: PillSize;
  variant?: PillVariant;
}

export function UrgentShiftPill(props: UrgentShiftPillProps) {
  const { compact = false, size = "small", variant = "filled" } = props;

  return (
    <Pill
      size={size}
      variant={variant}
      label={compact ? undefined : "Urgent"}
      iconType="clock-filled"
      backgroundColor={(theme) => theme.palette.shift?.urgent.background}
      color={(theme) => theme.palette.shift?.urgent.text}
      iconColor={(theme) => theme.palette.shift?.urgent.icon}
      sx={{
        width: "fit-content",
      }}
    />
  );
}
